'use strict';

angular.module('shiftTraderApp')
    .controller('DaysOffOverviewCtrl', function ($scope, user, me, $rootScope, Session, TimeService, $state) {
      $rootScope.$broadcast('setTopNavTitle', 'Days Off');
      $scope.me = me;
      $scope.user = user;

      $scope.startOfWeekDay = Session.getStartOfWeekDay();
      $scope.dateToday = TimeService.getNowInStoreTime().toDate();
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $rootScope.$broadcast('setTopNavTitle', $scope.user.name + '\'s Days Off Overview');

      $scope.state = {
      };

      $scope.pendingAndApprovedDaysOff = $scope.user.time_off_rules;

      $scope.goToDayoff = function(dayoff) {
        dayoff._isActive = true;
        $state.go('profile.daysOff.show', {userId: dayoff.user_id, dayOffId: dayoff.id});
      };
    });
